/**
 * Customer sales-process status: labels, select options, and a pill badge.
 * Shared by the customer list, detail, and form pages.
 */

import * as types from '../api/types';

export const CUSTOMER_STATUS_LABELS: Record<types.CustomerStatus, string> = {
  LEAD: 'Lead',
  PROSPECT: 'Prospect',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  LOST: 'Lost',
};

/** Pipeline order, used for select options. */
export const CUSTOMER_STATUS_OPTIONS: types.CustomerStatus[] = ['LEAD', 'PROSPECT', 'ACTIVE', 'INACTIVE', 'LOST'];

// Same pill styling as the Badge on CustomerDetailPage.
const STATUS_TONES: Record<types.CustomerStatus, string> = {
  LEAD: 'bg-gray-100 text-gray-700 ring-1 ring-inset ring-gray-200',
  PROSPECT: 'bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-200',
  ACTIVE: 'bg-green-50 text-green-700 ring-1 ring-inset ring-green-200',
  INACTIVE: 'bg-amber-50 text-amber-700 ring-1 ring-inset ring-amber-200',
  LOST: 'bg-red-50 text-red-700 ring-1 ring-inset ring-red-200',
};

const FALLBACK_TONE = STATUS_TONES.LEAD;

export function CustomerStatusBadge({ status }: { status: types.CustomerStatus }) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${STATUS_TONES[status] ?? FALLBACK_TONE}`}
    >
      {CUSTOMER_STATUS_LABELS[status] ?? status}
    </span>
  );
}
